var _style, _path, _defs, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E8ECEF;}\n\t.st1{clip-path:url(#SVGID_00000055704034446939455560000009494355685114338191_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#CB0606;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FB8D8D;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,0.5h262c6.9,0,12.5,5.6,12.5,12.5v262c0,6.9-5.6,12.5-12.5,12.5H13c-6.9,0-12.5-5.6-12.5-12.5V13 C0.5,6.1,6.1,0.5,13,0.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 110.3,
    y: 100,
    width: 67.4,
    height: 88
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158709552229329503810000003159480507340201875_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158709552229329503810000003159480507340201875_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.7,123.2v57.9c0,3.8-3.1,7-7,7h-53.5c-3.9,0-7-3.1-7-7v-74.1c0-3.8,3.1-7,7-7h37.2L177.7,123.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.7,121.9v2.9h-19c-3.9,0-5.7-3.2-5.7-7.1V100h2.9L177.7,121.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162,146.8c-0.6-0.2-1.2-0.3-1.7-0.3c-0.6,0-1.1,0.1-1.3,0.4c-0.2,0.3-0.4,0.7-0.4,1.4v1.3h2.7v2.6h-2.7 v10.5h-3.2v-10.5h-1.7v-2.6h1.7v-1.3c0-1.6,0.4-2.8,1.2-3.5c0.8-0.7,2-1.1,3.6-1.1c0.8,0,1.6,0.1,2.4,0.3L162,146.8z  M148.5,161.3c-0.6,0.5-1.2,0.9-1.9,1.2c-0.7,0.3-1.4,0.4-2.3,0.4c-1.6,0-2.9-0.6-3.8-1.8c-0.9-1.2-1.3-2.9-1.3-5 c0-2.2,0.5-3.9,1.4-5.2c1-1.2,2.3-1.8,4.1-1.8c0.6,0,1.2,0.1,1.9,0.4c0.6,0.3,1.2,0.6,1.6,1v-6.4h3.2v18.5h-3V161.3z  M148.3,153.2c-0.3-0.3-0.8-0.6-1.3-0.8c-0.5-0.2-1-0.4-1.5-0.4c-0.9,0-1.6,0.4-2.1,1.1c-0.5,0.7-0.8,1.7-0.8,3 c0,1.3,0.2,2.2,0.6,2.9c0.4,0.7,1.1,1.1,2,1.1c0.5,0,1.1-0.1,1.6-0.4c0.6-0.2,1-0.5,1.4-0.9V153.2z M134.5,162.2 c-0.8,0.6-1.7,0.8-2.8,0.8c-1.4,0-2.7-0.5-3.7-1.4v5.9h-3.2v-18h3v1.3c0.6-0.5,1.2-0.9,1.9-1.2c0.7-0.3,1.4-0.4,2.3-0.4 c1.7,0,2.9,0.6,3.8,1.7c0.9,1.2,1.3,2.8,1.3,5.1c0,1.4-0.2,2.6-0.6,3.7C135.9,160.8,135.3,161.6,134.5,162.2z M133,153.1 c-0.4-0.7-1.1-1.1-2-1.1c-0.5,0-1.1,0.1-1.6,0.4c-0.6,0.2-1,0.5-1.4,0.9v5.7c0.3,0.3,0.8,0.6,1.3,0.8s1,0.4,1.6,0.4 c0.9,0,1.6-0.4,2.1-1.1c0.5-0.8,0.8-1.7,0.8-3C133.6,154.8,133.4,153.8,133,153.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile01);
export default __webpack_public_path__ + "static/media/pdf-file-01.8bc1ee0b1439377edc15cf1002a65677.svg";
export { ForwardRef as ReactComponent };